import { render, staticRenderFns } from "./DocumentiDetails.vue?vue&type=template&id=2a39a025&scoped=true"
import script from "./DocumentiDetails.vue?vue&type=script&lang=js"
export * from "./DocumentiDetails.vue?vue&type=script&lang=js"
import style0 from "./DocumentiDetails.vue?vue&type=style&index=0&id=2a39a025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39a025",
  null
  
)

export default component.exports